<template>
    <vs-popup class="add-new-incoterms" id="popup" title="SYNC OPPORTUNITY WITH ORDERS" @close="open = false"
        :active.sync="open" :buttons-hidden="true">
        <vx-card no-shadow style="height: 30vh;">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form id="create-csutomer-crm-opportunity-popup" @submit.prevent="handleSubmit(onSyncOrders)"
                    autocomplete="off">
                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-full w-full md:mb-0">
                            <ValidationProvider vid="products" name="products" rules="" v-slot="{ errors }">
                                <small class="label">Products</small>
                                <v-select multiple :clearable="false" :closeOnSelect="false" name="products" placeholder=""
                                    label="product_order_code" v-model="selected_order_ids" :reduce="option => option.id"
                                    :options="product_orders" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template slot="option" slot-scope="option">
                                        <span>{{ option.product_order_code }}</span>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <span>{{ option.product_order_code }}</span>
                                    </template>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="flex flex-wrap items-center justify-end mt-8">
                        <vs-button button="submit" class="mt-2 ml-auto">Save
                            Changes</vs-button>
                    </div>
                </form>
            </ValidationObserver>
        </vx-card>
    </vs-popup>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const CustomerRepository = RepositoryFactory.get('customer')
const CrmRepository = RepositoryFactory.get('crm');

import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
    return {
        open: false,
        id: '',
        product_orders: [],
        customer_id: null,
        selected_order_ids: []
    }
}

export default {
    name: 'SyncOpportunityWithProductsPopUp',
    data() {
        return initialState()
    },
    methods: {
        async openPopup(id, customer_id) {
            try {
                await Object.assign(this.$data, initialState());
                this.open = true;
                this.id = id
                this.customer_id= customer_id
                await this.fetchOrders()
                await this.fetchBantData()
            } catch (error) {

            }
        },
        async fetchBantData() {
            try {
                const { data } = (await CrmRepository.getCustomerCrmOpportunity(this.id)).data
                this.selected_order_ids = data.product_orders.map((x) => x.id)
            } catch (error) {
                this.convertAndNotifyError(error);
            }
        },
        async fetchOrders() {
            try {
                const { data } = (await CustomerRepository
                    .getListOfProductOrders(this.customer_id, 1, '',
                        150, '')).data
                this.product_orders = data
            } catch (error) {

            }
        },
        async onSyncOrders() {
            try {
                await CrmRepository.syncOpportunityWithOrders(this.id, { order_ids: this.selected_order_ids })
                await this.$parent.refreshData();
                this.open = false;
            } catch (error) {
                this.convertAndNotifyError(error);
            }
        }
    },
    components: {
        'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
  
<style scoped>
.add-new-incoterms>>>.vs-popup {
    min-height: 40% !important;
    min-width: 40% !important;
}
</style>
  